<template>
  <div class="p-4">
    <AnalyticsChartContainer
      :name="apiName"
      :api="chartInfo.api"
      :period-list="chartInfo.periodList"
      :interval-list="chartInfo.intervalList"
      :single-select="chartInfo.singleSelect"
      :unit="chartInfo.unit"
      :y-max="chartInfo.yMax"
      :y-tick-amount="chartInfo.yTickAmount"
      :show-menu="false"
    />
  </div>
</template>

<script setup lang="ts">
import AnalyticsChartContainer from '~/components/@pages/analytics/AnalyticsChartContainer.vue'
import { ANALYTICS_CHART_API } from '~/constants/analytics.constants'

const route = useRoute()
const apiName = route.params.chartName as string

const chartInfo = computed(() => ANALYTICS_CHART_API[apiName])

definePageMeta({
  layout: false
})
</script>

<style scoped lang="scss">

</style>